'use strict'

import $ from 'jquery';
import Highcharts from 'highcharts/highstock';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { chartLib } from '../../common/ChartLibrary';

NoDataToDisplay(Highcharts);

/**
 * 銘柄比較 - 四半期業績 - 業績 グラフ生成クラス
 *
 * @param {string}  divId グラフ出力先の<div>タグのID
 * @param {string}  stockCd 銘柄コード
 * @param {string}  stockName 銘柄名
 * @param {string}  json データファイルJSON
 * @param {integer} kessanNum 決算期数
 */
const Comparison4qClass = function(divId, stockCd, stockName, json, kessanNum) {
    let jsonData = [],
        jsonEnv = []; // 環境用JSON

    if (kessanNum === undefined) {
        kessanNum = null;
    }

    try {
        //利用するJSONデータの抽出
        $.each(json, function(idx, data) {
            jsonData[idx] = data;
        });

        //表示年数が指定されている時、不要な過去データを削る
        if (kessanNum !== null) {
            //kessanNumに応じてデータを削る
            $.each(jsonData, function(idx, graphData) {
                jsonData[idx].data = graphData.data.slice(-kessanNum);
            });
        }

        // グラフデータの編集
        editGraphData(jsonData, jsonEnv);
        // グラフの生成
        // 説明：・設定用JSONP・データ用JSONPを使用して、グラフの設定を行う
        createGraph(divId, jsonData, jsonEnv);
    } catch (e) {
        $(divId).html('<span>該当するデータがありません</span>');
    }

    /**
     * グラフデータを編集
     * @param {object} jsonData - データJSON
     * @param {object} json_env - 環境JSON
     */
    function editGraphData(jsonData, json_env) {

        let dataCntKey,
            dataCnt = 0;

        if (jsonData[0].data !== undefined) {
            dataCntKey = Object.keys(jsonData[0].data).length - 1; // 配列のdata最大件数 - 1 が添え字の最大値
        } else {
            throw new Error();
        }

        // X軸のcategoriesに表示する項目をjsonから取得
        json_env['categories'] = [];
        json_env['tooltip'] = [];
        json_env['xAxis'] = [];
        if (jsonData[0] !== null) {
            while (dataCnt <= dataCntKey) {
                //categories
                //X軸件数が多いとラベルが入りきらないので、その場合は本決算のみ表示するようにする
                if (dataCntKey < 11 || jsonData[0].data[dataCnt][0].indexOf('本') !== -1) {
                    json_env['categories'].push(jsonData[0].data[dataCnt][0]);
                } else {
                    json_env['categories'].push('');
                }
                //tooltip表示用に保持
                json_env['tooltip'].push(jsonData[0].data[dataCnt][0]);
                dataCnt = (dataCnt+1)|0; //increment
            }
            //plotBands 本決算を境に、1年毎に背景色を付ける
            if (json_env['categories'].length > 0) {
                let plotBandsFlg = false,
                    plotBandsIdx = 0,
                    plotxAxis = [],
                    min,
                    max,
                    tmpPlotBands = {};
                $.each(json_env['categories'], function(idx, category) {
                    if (plotBandsFlg) {
                        //配列宣言
                        if (plotxAxis[plotBandsIdx] === undefined) {
                            plotxAxis[plotBandsIdx] = [];
                        }
                        //X軸のインデックスを保持
                        plotxAxis[plotBandsIdx].push(idx);
                    }
                    //本決算で表示フラグ切り替え
                    if (category.indexOf('本') !== -1) {
                        plotBandsFlg = ! plotBandsFlg;
                        plotBandsIdx++;
                    }
                });
                //年度切り替わり分plotBandsを設定
                $.each(plotxAxis, function(idx, val) {
                    if (val === undefined) {
                        return true;
                    }
                    tmpPlotBands = {};
                    //配列内の最大値最小値を取得
                    min = Math.min.apply(null, val);
                    max = Math.max.apply(null, val);
                    //plotBands情報を設定
                    tmpPlotBands = {
                        color: '#f0f0f6', //背景色
                        from: min - 0.5, //開始位置
                        to: max + 0.5 //終了位置
                    };
                    json_env['xAxis'].push(tmpPlotBands);
                });
            }
        }
    }

    /**
     * グラフを生成
     * @param {string} divId - グラフ出力先の<div>タグのID
     * @param {object} jsonData - jsonデータ
     * @param {object} json_env - 環境JSON
     */
    function createGraph(divId, jsonData, json_env) {
        Highcharts.setOptions({
            lang: {
                // 縦軸の数値にカンマ表示
                thousandsSep: ',',
                rangeSelectorZoom: '',
                // 表示データが無い時のメッセージ
                noData: '選択されているデータはありません',
            },
            // 表示をUTCからローカルタイムにする
            global: {
                useUTC: false
            }
        });

        $(divId).highcharts({
            chart: {
                style: {
                    fontFamily: $('#fontFamily').val()
                },
                animation: false
            },
            title: {
                text: '<a href="' + $('#zaimuUrl').val() + '/' + stockCd + '">' + stockName + ' (' + stockCd + ')</a>',
                margin: 0,
                useHTML: true,
                style: {
                    fontSize: '14px',
                    color: '#15c'
                }
            },
            //横軸
            xAxis: {
                title: {
                    text: null
                },
                categories: json_env.categories,
                tickmarkPlacement: 'between', //目盛線の位置 between,on
                tickPosition: 'inside', //目盛線の表示場所 inside:内側 outside:外側
                labels: {
                    style: {
                        color: '#000'
                    },
                    step: 1,
                    rotation: -45,
                    y: 12,
                    x: 2
                },
                //会社予測背景色
                plotBands: json_env['xAxis'],
                //ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //補助線の設定
                tickLength: 7,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                crosshair: true //マウスホバーした時の縦線表示設定
            },
            //縦軸
            yAxis: [{ //左側 0
                title: {
                    text: null
                },
                labels: {
                    formatter: function() {
                        let decimals = Math.getDecimalLength(this.value);
                        return Highcharts.numberFormat(this.value, decimals, '.', ',');
                    },
                    style: {
                        color: '#000'
                    },
                    x: -8
                },
                //赤字ライン
                plotLines: [{
                    color: '#53386d',
                    zIndex: 4, //Y軸罫線より手前に表示させる Y軸罫線は1なので2以上に設定
                    width: 1,
                    dashStyle: 'dash',
                    value: 0 //線を引く数値 0円
                }],
                //縦軸補助線の設定
                gridLineColor: '#c3c3c3',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid', //縦軸線スタイル dash:点線 solid:線
                //縦軸ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //縦軸補助線の設定
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                tickAmount: 7,
                tickPositioner: function () {
                    //tick値を計算する
                    return chartLib.calcTickPositions(this);
                }
            }, { //右側 1
                title: {
                    text: null
                },
                labels: {
                    formatter: function() {
                        let decimals = Math.getDecimalLength(this.value);
                        return Highcharts.numberFormat(this.value, decimals, '.', ',');
                    },
                    style: {
                        color: '#000'
                    },
                    x: 8
                },
                //縦軸補助線の設定
                gridLineColor: '#c3c3c3',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid', //縦軸線スタイル dash:点線
                //縦軸ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //縦軸補助線の設定
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                opposite: true, //true: 右側のy軸とする
                tickAmount: 7,
                tickPositioner: function () {
                    //tick値を計算する
                    return chartLib.calcTickPositions(this, 7, true);
                }
            }],
            //マウスホバー時の設定
            tooltip: {
                style: {
                    fontSize: '11px'
                },
                hideDelay: 100, //マウスを外してからtooltipが消えるまでの時間
                shared: true, //縦列グループ化
                useHTML: true,
                positioner: function(boxWidth, boxHeight, point) {
                    return chartLib.tooltipPositioner(this, boxWidth, boxHeight, point);
                },
                formatter: function() {
                    //X軸(決算期)は事前に保持しておいた値を使用
                    let xIndex = this.points[0].point.index,
                        xFiscal;
                    if (xIndex in json_env['tooltip']) {
                        xFiscal = json_env['tooltip'][xIndex];
                    } else {
                        xFiscal = this.x;
                    }
                    let tooltip = '<table><tr><td colspan="2">' + xFiscal + '</td></tr>',
                    //単位
                        suffix = ' 百万円',
                    //小数点表示桁数
                        digit = 0,
                    //シンボル
                        symbol = '●',
                        color;

                    $.each(this.points, function() {
                        color = this.series.color;
                        //置換文字を置換し、文字列結合
                        tooltip += '<tr>';
                        tooltip += '<td><span style="color:' + color + '">' + symbol + '</span> ' + chartLib.replaceStr(this.series.name) + ':</td>';
                        tooltip += '<td style="font-weight: bold; text-align: right">&nbsp;' + Highcharts.numberFormat(this.y, digit, '.', ',') + suffix + '</td>';
                        tooltip += '</tr>';
                    });
                    tooltip += '</table>';
                    return tooltip;
                }
            },
            //凡例 画面上に表示はさせないが、クリックイベントを実行可能状態にさせるため画面外部に出す
            legend: {
                floating: true,
                useHTML: true,
                x: 9999
            },
            exporting: false,
            credits: false, //右下公式クレジット表示設定
            plotOptions: {
                line: {
                    yAxis: 0,
                    animation: false,
                    zIndex: 2,
                    //折れ線グラフ点表示設定
                    marker: {
                        enabled: true,
                        radius: 2 //プロットの大きさ
                    }
                },
                column: {
                    animation: false,
                    pointWidth: 5,
                    borderWidth: 0,
                    zIndex: 1
                },
                series: {
                    states: {
                        inactive: {
                            //ホバーイベントのデフォルトを薄くしない（以前と同じに）
                            opacity: 1,
                        }
                    }
                }
            },
            //データ
            series: jsonData
        });
    }
};

export { Comparison4qClass };
